import React from 'react';
import { Chip } from '@mui/material';

export type LeadProductKey = 'mutui' | 'prestiti' | 'cessioni-del-quinto';

const LEAD_PRODUCT_CHIPS: Record<
  LeadProductKey,
  { label: string; backgroundColor: string }
> = {
  mutui: { label: 'Mutui', backgroundColor: 'rgba(17, 53, 75, 1)' },
  prestiti: { label: 'Prestiti', backgroundColor: 'rgba(5, 104, 158, 1)' },
  'cessioni-del-quinto': {
    label: 'Cqs',
    backgroundColor: 'rgba(196, 116, 46, 1)',
  },
};

interface LeadProductChipProps {
  product: LeadProductKey;
}

// Tells which product the lead list belongs to. It sits next to the list
// heading on every lead list page.
const LeadProductChip = ({ product }: LeadProductChipProps) => {
  const { label, backgroundColor } = LEAD_PRODUCT_CHIPS[product];

  return (
    <Chip
      label={label}
      sx={{
        bgcolor: backgroundColor,
        color: 'common.white',
        fontWeight: 'bold',
        // 3px over the 13px MUI Chip default.
        fontSize: '16px',
        '& .MuiChip-label': { px: 2 },
      }}
    />
  );
};

export default LeadProductChip;
